import React from 'react';
import ReactECharts from 'echarts-for-react';
import CyberCard from '../components/CyberCard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiAward, FiClock } = FiIcons;

export default function Analytics() {
  const focusChartOptions = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis', backgroundColor: '#0A0F1D', borderColor: '#1A233A', textStyle: { color: '#F4F1EA' } },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisLine: { lineStyle: { color: '#1A233A' } },
      axisLabel: { color: '#8A95A5', fontFamily: 'monospace' }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#1A233A', type: 'dashed' } },
      axisLabel: { color: '#8A95A5', formatter: '{value}h' }
    },
    series: [
      {
        name: 'Deep Work (hrs)',
        type: 'line',
        smooth: true,
        lineStyle: { width: 3, color: '#00F0FF', shadowColor: 'rgba(0, 240, 255, 0.5)', shadowBlur: 10 },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(0, 240, 255, 0.3)' },
              { offset: 1, color: 'rgba(0, 240, 255, 0)' }
            ]
          }
        },
        data: [3.2, 4.5, 2.8, 5.1, 4.8, 1.5, 2.0]
      }
    ]
  };

  const distractionChartOptions = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'item' },
    series: [
      {
        name: 'Distractions',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderColor: '#050914', borderWidth: 2 },
        label: { show: false },
        color: ['#00F0FF', '#4A5568', '#1A233A', '#F4F1EA'],
        data: [
          { value: 45, name: 'Social Media' },
          { value: 25, name: 'Email' },
          { value: 20, name: 'Internal Thoughts' },
          { value: 10, name: 'Environment' }
        ]
      }
    ]
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-light text-[#F4F1EA] mb-2">Weekly Synthesis</h1>
        <p className="text-[#8A95A5] font-mono-cyber text-sm">ANALYZING PERFORMANCE METRICS...</p>
      </div>

      {/* Top Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { label: 'Total Focus Time', value: '23h 45m', trend: '+12%', icon: FiClock, positive: true },
          { label: 'Avg Session Length', value: '42m', trend: '-3%', icon: FiTrendingUp, positive: false },
          { label: 'Distractions Logged', value: '18', trend: '-25%', icon: FiAward, positive: true },
        ].map((stat, i) => (
          <CyberCard key={i} className="relative overflow-hidden">
            <div className="flex justify-between items-start mb-4">
              <div className="p-2 bg-[#1A233A] rounded-lg">
                <SafeIcon icon={stat.icon} className="text-[#00F0FF]" />
              </div>
              <span className={`text-xs font-mono-cyber px-2 py-1 rounded ${stat.positive ? 'bg-emerald-500/10 text-emerald-400' : 'bg-rose-500/10 text-rose-400'}`}>
                {stat.trend} week
              </span>
            </div>
            <div className="text-3xl font-bold font-mono-cyber text-[#F4F1EA]">{stat.value}</div>
            <div className="text-[#8A95A5] text-sm mt-1">{stat.label}</div>
          </CyberCard>
        ))}
      </div>

      {/* Charts Area */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <CyberCard title="Focus Output (Rolling 7 Days)" className="lg:col-span-2 h-96">
          <ReactECharts option={focusChartOptions} style={{ height: '100%', width: '100%' }} />
        </CyberCard>

        <CyberCard title="Distraction Profile" className="h-96 flex flex-col">
          <div className="flex-1 -mt-4">
            <ReactECharts option={distractionChartOptions} style={{ height: '100%', width: '100%' }} />
          </div>
          <div className="mt-4 space-y-2">
            {distractionChartOptions.series[0].data.map((item, i) => (
              <div key={i} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: distractionChartOptions.series[0].color[i] }} />
                  <span className="text-[#8A95A5]">{item.name}</span>
                </div>
                <span className="font-mono-cyber text-[#F4F1EA]">{item.value}%</span>
              </div>
            ))}
          </div>
        </CyberCard>
      </div>
    </div>
  );
}